import React from 'react';

import './AgreementModal.scss';
import { Modal } from '@scuf/common';
import { IAPIPackage } from '../../commonUtils/APIContext';
import { EULAAgreementText } from './EULAAgreementText';
import { PrivacyPolicyText } from './PrivacyPolicyText';

interface IAgreementModalProps extends IAPIPackage {
  languageCode: string;
  title: string;
  type: string;
  onClose: (version: string) => void;
}

export const AgreementModal = (props: IAgreementModalProps) => {
  const VERSION = '1';
  return (
    <Modal
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
      closeIcon={true}
      onClose={() => props.onClose(VERSION)}
      open={true}
      size="large"
    >
      <Modal.Header>{props.title}</Modal.Header>
      <Modal.Content className='agreement-modal-content'>
        {props.type === 'EULA' ? EULAAgreementText(props.languageCode) : PrivacyPolicyText(props.languageCode)}
      </Modal.Content>
    </Modal>
  );
};

export default AgreementModal;
